export const buildQuery = (params: any) => {
  params = params || {}
  const query: any[] = []
  Object.keys(params).map((k) => {
    const v = params[k]
    if (Array.isArray(v)) {
      v.forEach((item) => query.push(`${encodeURIComponent(k)}=${encodeURIComponent(item)}`))
    } else if (v || typeof v == 'boolean' || k.includes('_gt')) {
      query.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    }
  })
  return query.join('&')
}

/**
 * Convert query params for API request.
 * If a value of a param is an array, it will be joined by a comma.
 * @param params The query parameters
 * @returns The converted query parameters
 */
export const convertQueryParams = (params: Record<string, any>) => {
  const result: Record<string, any> = { ...params }

  for (const key in result) {
    if (Array.isArray(result[key])) {
      result[key] = result[key].join(',')
    }
  }

  return result
}

export const normalizeQueryValue = (value: unknown): string | null => {
  if (Array.isArray(value)) {
    for (const item of value) {
      if (item === null || typeof item === 'undefined') continue
      const trimmed = String(item).trim()
      if (trimmed) return trimmed
    }
    return null
  }
  
  if (value === null || typeof value === 'undefined') return null
  const trimmed = String(value).trim()
  return trimmed ? trimmed : null
}
